export default {
  // 標題
  title: "提示",

  // 描述
  description:
    "以下列表中均為余額更新失敗的地址，點擊下方再次更新余額按鈕繼續查詢余額。",

  // 統計
  totalCount: "共計",
  totalData: "條數據",

  // 表格列名
  serialNumber: "序號",
  blockchain: "公鏈",
  address: "地址",

  // 按鈕
  back: "返回",
  updateBalanceAgain: "再次更新余額",
};
